const stripQueryAndHash = (value: string) => value.split(/[?#]/, 1)[0] || value;

/**
 * Public marketing surfaces that first-paint as white / light.
 * Keep in sync with `index.html` theme bootstrap `lightPaths` extras.
 */
const PUBLIC_LIGHT_SHELL_PATHS = new Set([
  "/start",
  "/bojt",
  "/bekapcs",
  "/bekapcs/sikeres",
  "/hirlevel",
  "/hirlevel/sikeres",
  "/hirlevel/confirm",
  "/taska",
  "/taska/sikeres",
]);

export function isPublicLightShellPath(pathname: string): boolean {
  const normalized = stripQueryAndHash(pathname);
  if (PUBLIC_LIGHT_SHELL_PATHS.has(normalized)) return true;
  if (normalized.startsWith("/hirlevel/")) return true;
  return false;
}

/** Hero / media first-paint routes: suppress early AppRouteRenderSignal. */
export const PUBLIC_VISUAL_READY_PATHS = new Set([
  "/home",
  "/start",
  "/bojt",
  "/bekapcs",
]);

export function isPublicVisualReadyPath(pathname: string): boolean {
  return PUBLIC_VISUAL_READY_PATHS.has(stripQueryAndHash(pathname));
}
